import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE, PROFILE_IMG_BASE } from "@config/env";


const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

const ORG_TYPES = [
  { value: 1, label: "Staffing / Consulting Firm",  icon: "fa-building", desc: "Match and deploy talent" },
  { value: 2, label: "Enterprise / End Client",     icon: "fa-city",     desc: "Find the right resources" },
  { value: 3, label: "Independent Contractor",      icon: "fa-user-tie", desc: "Manage your profile" },
];

export default function SignUpPage() {
  const navigate = useNavigate();
  const [form, setForm]     = useState({ organizationName:"", email:"", firstName:"", lastName:"", password:"", organizationType:1 });
  const [busy, setBusy]     = useState(false);
  const [error, setError]   = useState("");
  const [success, setSuccess] = useState("");

  const set = (k, v) => setForm(f => ({...f, [k]:v}));

  const validate = () => {
    if (!form.organizationName.trim()) return "Enter your organization name";
    if (!emailPattern.test(form.email)) return "Enter a valid email address";
    if (!form.firstName.trim()) return "Enter your first name";
    if (!form.lastName.trim()) return "Enter your last name";
    if (!form.password.trim()) return "Enter a password";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    if (err) { setError(err); return; }
    setBusy(true); setError("");
    const fd = new FormData();
    fd.append("firm_name", form.organizationName);
    fd.append("firm_type", form.organizationType);
    fd.append("email",     form.email);
    fd.append("password",  form.password);
    fd.append("first_name",form.firstName);
    fd.append("last_name", form.lastName);
    const res = await axios.post(`${API_BASE}create-firm-account`, fd).then(r=>r.data).catch(()=>null);
    setBusy(false);
    if (res?.status === 1) {
      setSuccess(res.message || "Account created! Please check your email to verify.");
    } else {
      setError(res?.message || "Unable to create account. Please try again.");
    }
  };

  const inp = (label, key, type="text", placeholder="") => (
    <div style={{ marginBottom:14 }}>
      <label style={{ fontSize:11, fontWeight:700, color:"#374151", display:"block", marginBottom:5, textTransform:"uppercase", letterSpacing:"0.05em" }}>{label}</label>
      <input type={type} value={form[key]} onChange={e=>set(key,e.target.value)} placeholder={placeholder||label}
        style={{ width:"100%", boxSizing:"border-box", padding:"10px 12px", border:"1.5px solid #E5E7EB", borderRadius:9, fontSize:13, outline:"none", fontFamily:"inherit", color:"#111827", transition:"all 0.18s" }}
        onFocus={e=>{e.target.style.borderColor="#2563EB";e.target.style.boxShadow="0 0 0 3px rgba(79,70,229,0.1)"}}
        onBlur={e=>{e.target.style.borderColor="#E5E7EB";e.target.style.boxShadow="none"}} />
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", background:"#F3F4F6", display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ width:"100%", maxWidth:520 }}>
        <div style={{ textAlign:"center", marginBottom:24 }}>
          <div style={{ fontSize:22, fontWeight:800, color:"#111827", letterSpacing:"-0.03em" }}>Firm<span style={{color:"#2563EB"}}>Connector</span></div>
          <p style={{ fontSize:13, color:"#6B7280", margin:"6px 0 0" }}>Create your organization account</p>
        </div>

        <div style={{ background:"#fff", borderRadius:20, boxShadow:"0 4px 24px rgba(0,0,0,0.06)", padding:"28px", border:"1px solid #E5E7EB" }}>
          {success ? (
            <div style={{ textAlign:"center", padding:"20px 0" }}>
              <div style={{ width:52, height:52, borderRadius:14, background:"#F0FDF4", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px" }}>
                <i className="fa-solid fa-envelope-circle-check" style={{ fontSize:22, color:"#16A34A" }} />
              </div>
              <h2 style={{ fontSize:18, fontWeight:700, color:"#111827", marginBottom:8 }}>Check your email</h2>
              <p style={{ fontSize:13, color:"#6B7280", marginBottom:24 }}>{success}</p>
              <Link to="/login" className="fc-btn fc-btn-md fc-btn-primary fc-btn-pill" style={{ textDecoration:"none" }}>Go to sign in</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {/* Org type */}
              <div style={{ marginBottom:18 }}>
                <label style={{ fontSize:11, fontWeight:700, color:"#374151", display:"block", marginBottom:8, textTransform:"uppercase", letterSpacing:"0.05em" }}>Organization Type</label>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8 }}>
                  {ORG_TYPES.map(t => (
                    <button key={t.value} type="button" onClick={() => set("organizationType", t.value)}
                      style={{ padding:"10px 8px", borderRadius:10, border:`2px solid ${form.organizationType===t.value?"#2563EB":"#E5E7EB"}`, background:form.organizationType===t.value?"#EFF6FF":"#fff", cursor:"pointer", fontFamily:"inherit", textAlign:"center", transition:"all 0.15s" }}>
                      <i className={`fa-solid ${t.icon}`} style={{ fontSize:16, color:form.organizationType===t.value?"#2563EB":"#9CA3AF", marginBottom:5, display:"block" }} />
                      <div style={{ fontSize:11, fontWeight:700, color:form.organizationType===t.value?"#2563EB":"#374151", lineHeight:1.3 }}>{t.label}</div>
                    </button>
                  ))}
                </div>
              </div>

              {inp("Organization Name", "organizationName")}

              {error && (
                <div style={{ padding:"10px 12px", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:9, marginBottom:14, fontSize:13, color:"#DC2626" }}>
                  <i className="fa-solid fa-circle-exclamation" style={{marginRight:7}} />{error}
                </div>
              )}

              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                <div style={{ marginBottom:14 }}>
                  <label style={{ fontSize:11, fontWeight:700, color:"#374151", display:"block", marginBottom:5, textTransform:"uppercase", letterSpacing:"0.05em" }}>First Name</label>
                  <input value={form.firstName} onChange={e=>set("firstName",e.target.value)} placeholder="First name"
                    style={{ width:"100%", boxSizing:"border-box", padding:"10px 12px", border:"1.5px solid #E5E7EB", borderRadius:9, fontSize:13, outline:"none", fontFamily:"inherit", color:"#111827" }}
                    onFocus={e=>{e.target.style.borderColor="#2563EB"}} onBlur={e=>{e.target.style.borderColor="#E5E7EB"}} />
                </div>
                <div style={{ marginBottom:14 }}>
                  <label style={{ fontSize:11, fontWeight:700, color:"#374151", display:"block", marginBottom:5, textTransform:"uppercase", letterSpacing:"0.05em" }}>Last Name</label>
                  <input value={form.lastName} onChange={e=>set("lastName",e.target.value)} placeholder="Last name"
                    style={{ width:"100%", boxSizing:"border-box", padding:"10px 12px", border:"1.5px solid #E5E7EB", borderRadius:9, fontSize:13, outline:"none", fontFamily:"inherit", color:"#111827" }}
                    onFocus={e=>{e.target.style.borderColor="#2563EB"}} onBlur={e=>{e.target.style.borderColor="#E5E7EB"}} />
                </div>
              </div>

              {inp("Email Address", "email", "email", "you@company.com")}
              {inp("Password", "password", "password", "Create a strong password")}

              <button type="submit" disabled={busy} className="fc-btn fc-btn-md fc-btn-primary" style={{ width:"100%", borderRadius:10, marginTop:6, opacity:busy?0.7:1 }}>
                {busy ? <><i className="fa-solid fa-spinner fa-spin" style={{fontSize:12}} /> Creating account...</> : "Create Account"}
              </button>
            </form>
          )}
        </div>

        <div style={{ textAlign:"center", marginTop:20, fontSize:13, color:"#9CA3AF" }}>
          Already have an account? <Link to="/login" style={{ color:"#2563EB", fontWeight:600, textDecoration:"none" }}>Sign in</Link>
        </div>
      </div>
    </div>
  );
}
